module.exports = __webpack_public_path__ + "static/media/scroll-right-thick2.239a32b1.png";